import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  PassThroughAdapterdbgnfuhbpbsv as PassThroughAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
} from './Adapters.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.j45_1 = (new (Builder())()).y36();
        this.k45_1 = (new (Builder())()).q45(true).y36();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.l45_1 = LinkedHashMap().bc();
        this.m45_1 = false;
        this.n45_1 = null;
        this.o45_1 = null;
        this.p45_1 = null;
      }
      r45(falseVariables) {
        // Inline function 'kotlin.apply' call
        this.n45_1 = falseVariables;
        return this;
      }
      s45(deferredFragmentIdentifiers) {
        // Inline function 'kotlin.apply' call
        this.o45_1 = deferredFragmentIdentifiers;
        return this;
      }
      t43(errors) {
        // Inline function 'kotlin.apply' call
        this.p45_1 = errors;
        return this;
      }
      t45(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.l45_1.z4(customScalarAdapters.y45_1);
        return this;
      }
      q45(unsafe) {
        // Inline function 'kotlin.apply' call
        this.m45_1 = unsafe;
        return this;
      }
      a5() {
        this.l45_1.a5();
      }
      y36() {
        return new (CustomScalarAdapters())(this.l45_1, this.n45_1, this.o45_1, this.p45_1, this.m45_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors, unsafe) {
        Key_getInstance();
        this.u45_1 = falseVariables;
        this.v45_1 = deferredFragmentIdentifiers;
        this.w45_1 = errors;
        this.x45_1 = unsafe;
        this.y45_1 = customScalarAdapters;
      }
      z45(customScalar) {
        var tmp;
        if (!(this.y45_1.u4(customScalar.g45_1) == null)) {
          tmp = this.y45_1.u4(customScalar.g45_1);
        } else if (customScalar.f45_1 === 'com.apollographql.apollo.api.Upload') {
          tmp = get_UploadAdapter();
        } else if (listOf(['kotlin.String', 'java.lang.String']).t2(customScalar.f45_1)) {
          tmp = get_StringAdapter();
        } else if (listOf(['kotlin.Boolean', 'java.lang.Boolean']).t2(customScalar.f45_1)) {
          tmp = get_BooleanAdapter();
        } else if (listOf(['kotlin.Int', 'java.lang.Int']).t2(customScalar.f45_1)) {
          tmp = get_IntAdapter();
        } else if (listOf(['kotlin.Double', 'java.lang.Double']).t2(customScalar.f45_1)) {
          tmp = get_DoubleAdapter();
        } else if (listOf(['kotlin.Long', 'java.lang.Long']).t2(customScalar.f45_1)) {
          tmp = get_LongAdapter();
        } else if (listOf(['kotlin.Float', 'java.lang.Float']).t2(customScalar.f45_1)) {
          tmp = get_FloatAdapter();
        } else if (listOf(['kotlin.Any', 'java.lang.Object']).t2(customScalar.f45_1)) {
          tmp = get_AnyAdapter();
        } else if (this.x45_1) {
          tmp = new (PassThroughAdapter())();
        } else {
          // Inline function 'kotlin.error' call
          var message = "Can't map GraphQL type: `" + customScalar.g45_1 + '` to: `' + customScalar.f45_1 + '`. Did you forget to add a scalar Adapter?';
          throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return (!(tmp_0 == null) ? isInterface(tmp_0, Adapter()) : false) ? tmp_0 : THROW_CCE();
      }
      m3() {
        return Key_getInstance();
      }
      e43() {
        return (new (Builder())()).t45(this).r45(this.u45_1).s45(this.v45_1);
      }
    }
    protoOf($).a46 = get;
    protoOf($).b46 = fold;
    protoOf($).c46 = minusKey;
    protoOf($).r43 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance4887rkxhu93r,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
